export enum SearchBoxVariant {
  ORDER,
  QUOTE,
}
